// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_oq4","cls2":"LoswpPackPitch-cls2_XDX LoswpPackPitch-cls1_oq4"};